export default "__VITE_ASSET__C9QuPPQp__"